import { render, staticRenderFns } from "./ModalBeingVerifiedByAdmin.vue?vue&type=template&id=27db989e&"
import script from "./ModalBeingVerifiedByAdmin.vue?vue&type=script&lang=js&"
export * from "./ModalBeingVerifiedByAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports